module.exports = __webpack_public_path__ + "img/3.4c756d35.png";